import { Contact } from '../../features/contacts/contact.model';
import { TeamMember } from '../../features/team/team.model';
import { Purchase } from '../../features/projects/purchase.model';
import * as _ from 'lodash';
import * as moment from 'moment';
import { extendMoment } from 'moment-range';
import { CurrencyPipe } from '@angular/common';
const { range } = extendMoment(moment);

export class Communication {

    _id?: string;
    commsType?: string = 'Phone';
    commsDate?: Date = new Date;
    content?: string;

    /* people involved */
    contacted: Contact[] = [];
    employees: TeamMember[] = [];

    /* people involved */
    //  companies: Company[] = [];
    //  projects: Project[] = [];
    purchase: Purchase;
    //  events: EventBB[] = [];
    outcome?: string;
    action?: string;

    createdBy?: string;
    modifiedBy?: string;
    createdAt?: Date;
    modifiedAt?: Date;

}

export class CommsTimelinePoint {
    date: string;
    outcome: string;
    action: string;
    count: number = 0;
    percent?: number = 0;
}
export class CommsTimeline {

    timeline: CommsTimelinePoint[];
    actionsTimeline: ChartTimeline[] = [];
    outcomesTimeline: ChartTimeline[] = [];

    get getActionsTotals(): any[] {
        return _(this.timeline)
                .groupBy('action')
                .map((action, id) => ({
                    action: id,
                    count: _.sumBy(action, 'count'),
                    percent: _.sumBy(action, 'percent')
                })).value();
    }
    get getOutcomeTotals() {
        return _(this.timeline)
        .groupBy('outcome')
        .map((action, id) => ({
            action: id,
            count: _.sumBy(action, 'count'),
            percent: _.sumBy(action, 'percent')
        })).value();
    }

    constructor(timeline: Partial<CommsTimeline> = {}) {
        Object.assign(this, timeline);
        this.getChartTimelines();
    }

    getOutcomeSummary() {

    }
    // generateTimeDelayTimeseries(period: string = 'w', startDate: moment.Moment = moment().endOf('day'), endDate: moment.Moment = moment().endOf('day') ): TimeSeriesPoint[] {

    //     // run the iteration sum
    //     const abc = this.timeSeries.reduce((val, currentDate, index) => {

    //         const comparison = currentDate.date; // .format(period);
    //         const comparisonStart = comparison.startOf(<moment.unitOfTime.StartOf>period);
    //         const comparisonEnd = comparison.endOf(<moment.unitOfTime.StartOf>period);
    //         const betweenDates = comparisonStart.format('MMM DD') + ' to ' + comparisonEnd.format('MMM DD');

    //         val[comp] = val[comp] || []).push(currentDate);
    //         return val;

    //       }, []);
    //     return abc;

    // }

    getChartTimelines() {

        // get a list of the unqieu entries in the timeline
        const listOfActions = _.uniq(this.timeline.map(x => x.action)); // || 'No Action'
        const listOfOutcomes = _.uniq(this.timeline.map(x => x.outcome)); // || 'No Outcome'

        // loop through the lists and generate the timeseries
        listOfActions.forEach(action => {
            this.actionsTimeline.push(
                new ChartTimeline(
                    { name: action || 'No Action', timeSeries: this.getTimelineByAction(action) }
                ));
        });
        listOfOutcomes.forEach(outcome => {
            this.outcomesTimeline.push(
                new ChartTimeline(
                    { name: outcome || 'No Outcome', timeSeries: this.getTimelineByOutcome(outcome) }
                )
            );
        });

    }

    getBlankTimeSeries(): TimeSeriesPoint[] {

        // get a unique list of the dates
        const uniqueList = _.uniqBy(this.timeline.map(tp => ({ date: tp.date, value: 0 })), 'date');

        // convert them to moments, and get the min/max
        const moments = uniqueList.map(d => moment(d.date, 'YYYY-MM-DD'));
        const maxDate = moment.max(moments);
        const minDate = moment.min(moments);

        // finally create a full list from the range
        const timeRange = range(minDate, maxDate);
        const timeSeries = Array.from(timeRange.by('day', { step: 1 })).map(d => ({ date: d, value: 0 }));

        return timeSeries;

    }


    getTimelineByAction(action: string): TimeSeriesPoint[] {

        // get a full blank timeline to use
        const timeSeries = this.getBlankTimeSeries();

        this.timeline.filter(tp => tp.action === action).forEach(tp => {
            // find the ts and add the point
            timeSeries.find(bs => bs.date.format('YYYY-MM-DD') === tp.date).value += tp.count;
        });

        return timeSeries;
    }

    getTimelineByOutcome(outcome: string): TimeSeriesPoint[] {

        // get a full blank timeline to use
        const timeSeries = this.getBlankTimeSeries();

        this.timeline.filter(tp => tp.outcome === outcome).forEach(tp => {
            // find the ts and add the point
            timeSeries.find(bs => bs.date.format('YYYY-MM-DD') === tp.date).value += tp.count;
        });

        return timeSeries;
    }

}

export class TimeSeriesPoint {
    date: moment.Moment;
    value: number = 0;
    // get weekNumber() { return this.date.format('w'); }
    // get month() { return this.date.format('M'); }
    // get year() { return this.date.format('Y'); }
}
export class ChartTimeline {

    timeSeries: TimeSeriesPoint[] = [];
    name?: string;
    order?: number = 999;
    identifier?: string;

    // chart customisation options
    fill ?: boolean = true;
    type?: string = 'bar';

    get color(): string {
        switch (this.name) {
            case 'Spoke to Contact - Successful call':
            case 'Send NDA':
                return '#9CCC65';
            case 'Engaged conversation but not the right contact':
            case 'Email To Be Resent':
                return '#25C5DA';
            case 'Called but no response':
            case 'Find Right Contact':
                return '#FFCA27';
            case 'Try To Call Again':
            case 'Wrong contact details':
                return '#EF534F';
            case 'Further Call Booked':
                return '#42A5F6';
            case 'No Outcome':
            case 'No Action':
            default:
                return '#575757';
        }
    }

    // get getWeeklyTimeSeries() { return this.generateTimeDelayTimeseries('d'); }
    // get getMonthlyTimeSeries() { return this.generateTimeDelayTimeseries('m'); }
    // get getYearlyTimeSeries() { return this.generateTimeDelayTimeseries('y'); }


    constructor(chartTimeline: Partial<ChartTimeline> = {}) {
        Object.assign(this, chartTimeline);
    }

    getChartLabelSeries() {
        return this.timeSeries.map(ts => ts.date.format('MMM DD'));
    }
    getChartDataSeries() {
        return {
            type: this.type, // cumulative should always be a line (?)
            data: this.timeSeries.map(dp => dp.value),
            label: this.name,
            borderWidth: 1,
            borderColor: this.color,
            backgroundColor: this.hexToRgbA(this.color, '0.2'),
            hoverBackgroundColor: this.color,
            hoverBorderColor: this.color, // this.hexToRgbA(this.color, '0.2'),
            hoverBorderWidth: 1,
            borderSkipped: 'bottom',
            radius: 0,
            fill: this.fill
        };
    }

    hexToRgbA(hex: string, alpha: string = '0.05') {
        let c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            // tslint:disable-next-line:no-bitwise
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', ' + alpha + ')';
        }
        throw new Error('Bad Hex');
    }

}




// WEBPACK FOOTER //
// ./client/app/shared/communications/communication.model.ts